import React, { useEffect } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Divider, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CommentDrawer from '../Common/Drawer';
import { createIndustry, updateIndustry } from '../../store/industrySlice';
import _ from 'lodash';
import { setDomainList } from '../../store/domainSlice';

export default function IndustryForm({ setResetTrigger, page, setPage, getIndustries, title, industryModal, setIndustryModal, resetTrigger, selectedIndustry = null }) {
    const dispatch = useDispatch();
    let domains = useSelector((state) => state.domainReducer.domainList)
    const [isButtonDisabled, setIsButtonDisabled] = React.useState();
    const validationSchema = Yup.object({
        title: Yup.string().required("Title is required")
            .max(30, "Title cannot exceed 30 characters"),
        description: Yup.string()
            .max(400, "Title cannot exceed 400 characters"),
        domain_ids: Yup.array()
    });

    const formik = useFormik({
        initialValues: {
            title: "",
            description: "",
            domain_ids: [],
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setIndustryModal(false);
            values.domain_ids = values?.domain_ids?.filter((item) => item !== 'all');
            if (selectedIndustry) {

                values.id = selectedIndustry.uuid;
                dispatch(updateIndustry(values)).then(() => {
                    getIndustries()
                })
            } else {
                dispatch(createIndustry(values)).then(() => {
                    if (page) {
                        setPage(0)
                    } else {
                        getIndustries()
                    }
                })
            }
        },
    });
    const allOptionId = 'all';
    const allOptionLabel = 'All';
    const allIndustryIds = domains?.map((ele) => ele.id);
    useEffect(() => {
        if (selectedIndustry?.title && industryModal) {

            const selectedDomains = selectedIndustry.domains?.map((ele) => ele.id)
            const isAll = _.isEqual([...selectedDomains].sort(), [...allIndustryIds].sort())

            formik.setValues({
                title: selectedIndustry.title,
                description: selectedIndustry.description,
                domain_ids: isAll ? ["all", ...selectedDomains] : selectedDomains || [],
            });
            // domains = [...domains, ...selectedIndustry.domains]

        } else {
            formik.resetForm();
        }
    }, [selectedIndustry, industryModal, resetTrigger, domains]);

    useEffect(() => {
        if (selectedIndustry) {
            const disabled = JSON.stringify({
                "title": formik.values?.title,
                "description": formik.values?.description,
                "domain_ids": formik?.values?.domain_ids?.filter((ele) => ele !== "all"),
            }) === JSON.stringify({
                "title": selectedIndustry.title,
                "description": selectedIndustry.description,
                "domain_ids": selectedIndustry.domains,
            });
            setIsButtonDisabled(disabled)
        }
    }, [selectedIndustry, formik.values])

    // useEffect(() => {
    //     console.log("");


    // }, [industryModal ])
    useEffect(() => {
        if (!industryModal) {
            setResetTrigger(!resetTrigger)
        }
        if (selectedIndustry?.domains?.length) {
            const merged = [...domains, ...selectedIndustry.domains];
            const deduped = _.uniqBy(merged, 'id'); // remove duplicates
            dispatch(setDomainList(deduped));
        }
    }, [industryModal])

    return (
        <CommentDrawer open={industryModal} setOpen={setIndustryModal}>
            <Box className="position-relative h-100">
                <form onSubmit={formik.handleSubmit} >
                    <Typography variant="h6" gutterBottom className='p-3'>
                        {title}
                    </Typography>
                    <Divider />
                    <div className='role-form-scroller px-3'>
                        <TextField
                            fullWidth
                            required
                            id="title"
                            name="title"
                            label="Title"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.title && Boolean(formik.errors.title)}
                            helperText={formik.touched.title && formik.errors.title}
                        />
                        <TextField
                            fullWidth
                            id="description"
                            name="description"
                            label="Description"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.description && Boolean(formik.errors.description)}
                            helperText={formik.touched.description && formik.errors.description}
                        />
                        <FormControl
                            fullWidth
                            className="mt-3"
                            sx={{ maxHeight: 20 }}
                            error={formik.touched.domain_ids && Boolean(formik.errors.domain_ids)}
                        >
                            <InputLabel id="domain_ids">Domain</InputLabel>
                            <Select
                                labelId="domain_ids"
                                id="domain_ids"
                                name="domain_ids"
                                label="Domain"
                                className='domain-select-wrapper'
                                multiple
                                value={formik.values?.domain_ids || []}
                                onChange={(event) => {
                                    const value = event.target.value;

                                    const isAllSelected = formik?.values?.domain_ids?.includes(allOptionId);
                                    const justClickedAll = value.includes(allOptionId) && !isAllSelected;
                                    const justUnclickedAll = !value.includes(allOptionId) && isAllSelected;


                                    if (justClickedAll) {
                                        formik.setFieldValue('domain_ids', [allOptionId, ...allIndustryIds]);

                                    } else if (justUnclickedAll) {
                                        formik.setFieldValue('domain_ids', []);
                                    } else {
                                        const filtered = value.filter(val => val !== allOptionId);

                                        if (filtered?.length === allIndustryIds?.length) {
                                            formik.setFieldValue('domain_ids', [allOptionId, ...filtered]);
                                        } else {
                                            formik.setFieldValue('domain_ids', filtered);
                                        }
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                onBlur={formik.handleBlur}
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <Typography color="textSecondary">Select domains</Typography>;
                                    } else {
                                        return (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }} className="multi-selection-box-wrapper">
                                                {selected.map((id) => {
                                                    const domain = [...domains,].find((ele) => ele?.id === id);
                                                    return (
                                                        domain && <Chip
                                                            key={id}
                                                            label={domain?.route || id}
                                                            onMouseDown={(e) => e.stopPropagation()}
                                                            onDelete={() => {
                                                                // const newSelected = formik.values?.domain_ids?.filter(item => item !== id);
                                                                const newSelected = formik.values?.domain_ids.filter(
                                                                    item => item !== id && item !== "all"
                                                                );
                                                                formik.setFieldValue('domain_ids', newSelected);
                                                            }}
                                                            className="role-permission mr-2"
                                                        />
                                                    );
                                                })}
                                            </Box>
                                        );
                                    }
                                }}
                            >
                                {(!domains || domains?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No domains found.
                                    </MenuItem>
                                )}
                                {domains?.length > 0 &&
                                    <MenuItem key={allOptionId} value={allOptionId}>
                                        <Checkbox checked={formik.values.domain_ids?.includes(allOptionId)} />
                                        <ListItemText primary={allOptionLabel} />
                                    </MenuItem>}
                                {domains?.length > 0 &&
                                    domains?.map((ele) => (
                                        <MenuItem key={ele.id} value={ele.id}>
                                            <Checkbox checked={formik.values.domain_ids?.includes(ele.id)} />
                                            <ListItemText primary={ele.route} />
                                        </MenuItem>
                                    ))}
                            </Select>
                            {formik.touched.domain_ids && formik.errors.domain_ids && (
                                <FormHelperText className='text-danger'>{formik.errors.domain_ids}</FormHelperText>
                            )}
                        </FormControl>
                    </div>
                    <Box className="drawer-footer m-3">
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={() => setIndustryModal(false)}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="mt-2"
                            disabled={selectedIndustry ? (isButtonDisabled || !formik.isValid) : !(formik.dirty && formik.isValid)}
                        >
                            Save
                        </Button>
                    </Box>
                </form>
            </Box>
        </CommentDrawer>
    );
}